// /var/www/customers.nginx.encasa/client/src/utils/timestamp-formatter.js

export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return `${year}-${month}-${day} ${hours}:${minutes} ${tz}`;
};

